import React from 'react'
import Contactpage from "../Components/Contact/Contact"

const Contact = () => {
  return (
   <Contactpage/>
  )
}

export default Contact